import PropTypes from 'prop-types';

export const FormOptionsPropTypes = PropTypes.shape({
  adjException: PropTypes.bool,
  allowTopside: PropTypes.bool,
  allowFbosFlag: PropTypes.bool,
  glAccountList: PropTypes.string,
  toAdj: PropTypes.bool,
  toFromAdj: PropTypes.bool,
  toAccount: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }),
});

const FormFieldPropTypes = PropTypes.shape({
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  isValid: PropTypes.bool,
});

export const FormDataPropTypes = PropTypes.shape({
  amountHasChanged: FormFieldPropTypes,
  glAccountOverride: FormFieldPropTypes,
  adjustmentException: FormFieldPropTypes,
  fromTaxEntryAccountId: FormFieldPropTypes,
  taxEntryAccountId: FormFieldPropTypes,
  topsideFlag: FormFieldPropTypes,
  comment: FormFieldPropTypes,
  files: PropTypes.arrayOf(PropTypes.instanceOf(File)),
});
